export default "__VITE_ASSET__036362d6__"